import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button, DatePicker } from 'antd';
import { Input } from 'valuelink/lib/tags';
import moment from 'moment';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import { fetchDoctorAwards, deleteAward, updateAward } from '../../services';

const { RangePicker } = DatePicker;

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const AwardRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const AwardNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const AwardInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const AwardText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorAwardScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      awards: [],
      doctorAwardId: null,
      title: '',
      remark: '',
      fromDate: '',
      toDate: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchAward();
  };

  fetchAward = () => {
    const { dispatch } = this.props;
    fetchDoctorAwards(this.doctorId).then(res => {
      const awards = res.data;
      dispatch(setDoctorProfile({ awards }));
      this.setState({
        awards,
      });
    });
  };

  submit = () => {
    const { doctorAwardId, title, remark, fromDate, toDate } = this.state;

    updateAward({
      doctorId: this.doctorId,
      doctorAwardId,
      title,
      remark,
      fromDate,
      toDate,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchAward();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteAward = doctorAwardId => {
    deleteAward(this.doctorId, doctorAwardId)
      .then(() => {
        message.success('Award deleted successfully');
        this.fetchAward();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editAward = edu => {
    this.setState({
      formEditing: true,
      doctorAwardId: edu.doctorAwardId,
      title: edu.title || '',
      remark: edu.remark || '',
      fromDate: edu.fromDate || '',
      toDate: edu.toDate || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorAwardId: null,
      title: '',
      remark: '',
      fromDate: '',
      toDate: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onCurrentChange = e => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      current: e.target.checked,
    });
  };

  render() {
    const { awards } = this.state;
    const titleLink = Link.state(this, 'title');
    const remarkLink = Link.state(this, 'remark');

    const awardsForm = () => {
      console.log({ state: this.state });
      return (
        <AwardRow>
          <BodyContainer>
            <LabelText>Award Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="title"
            />

            <LabelText>Remark</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={remarkLink}
              placeholder="remark"
            />

            <LabelText>From Date - To Date</LabelText>
            <RangePicker
              onChange={this.onFromToDateChange}
              style={{ marginBottom: 20 }}
              defaultValue={
                this.state.fromDate
                  ? [
                      moment(this.state.fromDate, 'YYYY-MM-DD'),
                      moment(this.state.toDate, 'YYYY-MM-DD'),
                    ]
                  : null
              }
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </AwardRow>
      );
    };

    const renderAward = (edu, idx) => (
      <AwardRow>
        <EduRowComponent>
          <AwardNumber>{idx + 1}. </AwardNumber>
          <AwardInfo>
            <AwardText>{edu.title}</AwardText>
            <AwardText>
              {`${edu.remark}, From: ${edu.fromDate} To:${edu.toDate}`}
            </AwardText>
          </AwardInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editAward(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() => this.deleteAward(edu.doctorAwardId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </AwardRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Award Screen</TitleText>
        <ColContainer>{awards.map(renderAward)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editAward({})}
          >
            Add Award
          </Button>
        )}
        {this.state.formEditing && awardsForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorAwardScreen);
